<template>
  <div @click="handleClick" class="btn --red">
    <i class="fas fa-door-open"></i>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { checkIn } from '../../../services/endpoints';

export default {
  props: {
    id: Number,
  },

  computed: {
    ...mapState({
      pin: state => state.auth.pin,
    }),
  },

  methods: {
    handleClick() {
      checkIn(this.id, this.pin);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Booking/ActionButtons/Checkin.vue